"use client";

import React, {useState} from "react";
import Image from "next/image";
import {motion, AnimatePresence} from "framer-motion";
import {CourseEntity, CurrencyEnum} from "@/types/course";
import {checkDiscountCode} from "@/app/(dashboard)/dashboard/admin/discount/actions";
import {CalculateFinalPrice} from "@/components/text/price.lib";

interface PaymentModalProps {
    isOpen: boolean,
    onClose: () => void,
    course: CourseEntity,
    onPay: (code: string | undefined, amount: number | undefined) => void
}

export default function PaymentModal({isOpen, onClose, course, onPay}: PaymentModalProps) {
    const [discountCode, setDiscountCode] = useState("");
    const [discount, setDiscount] = useState(0);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleApplyDiscount = () => {
        setLoading(true);

        checkDiscountCode(discountCode).then((detail) => {
            if(detail?.success !== true){
                setDiscount(0);
                setError("کد تخفیف معتبر نیست");
                return;
            }

            const percentage = detail.amount / 100;
            setDiscount(percentage);
            setError('');

        }).finally(() => {
            setLoading(false);
        });
        //
        // setTimeout(() => {
        //     // شبیه‌سازی اعتبارسنجی کد تخفیف
        //     if (discountCode.trim().toLowerCase() === "off20") {
        //         setDiscount(0.2); // 20 درصد تخفیف
        //         setError("");
        //     } else if (discountCode.trim().toLowerCase() === "off50") {
        //         setDiscount(0.5); // 50 درصد تخفیف
        //         setError("");
        //     } else {
        //         setDiscount(0);
        //         setError("کد تخفیف معتبر نیست");
        //     }
        //     setLoading(false);
        // }, 600);
    };

    const {finalPrice: fP, priceWithDiscount} = CalculateFinalPrice(course);
    let price = fP;

    if(priceWithDiscount){ price = priceWithDiscount; }

    const finalPrice = Math.max(price - price * discount, 0);

    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm p-4"
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    exit={{opacity: 0}}
                >
                    <motion.div
                        className="w-full m-4 sm:m-6 max-w-sm p-4 bg-white border border-stone-300 hover:border-stone-300 hover:dark:border-stone-600 rounded-xl hover:rounded-2xl shadow hover:shadow-lg transition-all duration-300 sm:p-6 md:p-8 dark:bg-stone-900 dark:border-stone-700"
                        initial={{scale: 0.9, opacity: 0}}
                        animate={{scale: 1, opacity: 1}}
                        exit={{scale: 0.9, opacity: 0}}
                    >
                        <div className="flex flex-col items-center space-y-4">
                            <div
                                className="aspect-video bg-stone-500/30 grid items-center justify-center mb-2 rounded-xl w-full">
                                <Image
                                    src={course.cover ?? '/images/user-placeholder.jpg'}
                                    alt={course.coverAlt ?? course.title}
                                    width={0}
                                    height={0}
                                    className="aspect-video object-cover rounded-xl overflow-hidden"
                                    loading={'lazy'}
                                    sizes="100vw"
                                    style={{width: '100%', height: 'auto'}}/>
                            </div>

                            <h2 className="text-xl font-semibold text-stone-800 dark:text-stone-100 text-center">
                                {course.title}
                            </h2>

                            <p className="text-sm text-stone-500 dark:text-stone-400 text-center">
                                {course.des}
                            </p>

                            <div className="w-full">
                                {/*<label className="block text-stone-700 dark:text-stone-300 mb-1">*/}
                                {/*    کد تخفیف*/}
                                {/*</label>*/}
                                <div className="flex gap-2">
                                    <input
                                        type="text"
                                        value={discountCode}
                                        onChange={(e) => setDiscountCode(e.target.value)}
                                        className="flex-1 px-3 py-2 rounded-lg border border-stone-300 dark:border-stone-600 bg-transparent text-stone-800 dark:text-stone-100 focus:outline-none focus:ring-2 focus:ring-stone-400"
                                        placeholder="کد تخفیف"
                                    />
                                    <button
                                        onClick={handleApplyDiscount}
                                        disabled={loading}
                                        className="px-4 py-2 bg-stone-800 text-white rounded-lg hover:bg-stone-700 transition"
                                    >
                                        {loading ? "..." : "اعمال"}
                                    </button>
                                </div>
                                {error && (
                                    <p className="text-red-500 text-sm mt-2 text-right">{error}</p>
                                )}
                            </div>

                            <div className="w-full text-right mt-4">
                                {discount > 0 && (
                                    <p className="text-green-600 dark:text-green-400 text-sm mb-1">
                                        {discount * 100}% تخفیف اعمال شد
                                    </p>
                                )}
                                <p className="text-lg font-bold text-stone-800 dark:text-stone-100">
                                    مبلغ نهایی:{" "}
                                    <span className="text-green-600">
                    {finalPrice.toLocaleString("fa-IR")} تومان
                  </span>
                                </p>
                            </div>

                            <div className="flex w-full gap-2 mt-6">
                                <button
                                    onClick={onClose}
                                    className="flex-1 py-2 rounded-lg border border-stone-400 dark:border-stone-600 text-stone-600 dark:text-stone-300 hover:bg-stone-100 dark:hover:bg-stone-800 transition"
                                >
                                    انصراف
                                </button>
                                <button
                                    onClick={() => {
                                        onPay(discountCode, discount);
                                    }}
                                    className="flex-1 py-2 rounded-lg bg-green-600 text-white hover:bg-green-700 transition"
                                >
                                    { finalPrice === 0 ? 'دریافت رایگان' : "پرداخت"}
                                </button>
                            </div>
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
